import { css } from '@emotion/react';
import { rgba } from 'polished';
import { breakpointInfix, MediaBreakpointUp } from '../mixins/_breakpoints.mixin';
import { TextTruncate } from '../mixins/_text-truncate.mixin';
import { TextEmphasisVariant } from '../mixins/_text-emphasis.mixin';
import { TextHide } from '../mixins/_text-hide.mixin';



export default $ => css`
  .text-monospace { font-family: ${$.fontFamilyMonospace} !important; }

  .text-justify { text-align: justify !important; }
  .text-wrap { white-space: normal !important; }
  .text-nowrap { white-space: nowrap !important; }
  .text-truncate {
    ${new TextTruncate().include($)}
  }

  ${css(Object.keys($.gridBreakpoints).map((breakpoint) => {
    const infix = breakpointInfix($, breakpoint, $.gridBreakpoints);

    return new MediaBreakpointUp(breakpoint).include($, css`
      .text${infix}-left { text-align: left !important; }
      .text${infix}-right { text-align: right !important; }
      .text${infix}-center { text-align: center !important; }
    `);
  }))}

  .text-lowercase { text-transform: lowercase !important; }
  .text-uppercase { text-transform: uppercase !important; }
  .text-capitalize { text-transform: capitalize !important; }

  .font-weight-light { font-weight: ${$.fontWeightLight} !important; }
  .font-weight-lighter { font-weight: ${$.fontWeightLighter} !important; }
  .font-weight-normal { font-weight: ${$.fontWeightNormal} !important; }
  .font-weight-bold { font-weight: ${$.fontWeightBold} !important; }
  .font-weight-bolder { font-weight: ${$.fontWeightBolder} !important; }
  .font-italic { font-style: italic !important; }

  .text-white { color: ${$.white} !important; }

  ${css(Object.entries($.themeColors).map(([color, value]) => 
    new TextEmphasisVariant(`.text-${color}`, value, true).include($)
  ))}

  .text-body { color: ${$.bodyColor} !important; }
  .text-muted { color: ${$.textMuted} !important; }

  .text-black-50 { color: ${rgba($.black, 0.5)} !important; }
  .text-white-50 { color: ${rgba($.white, 0.5)} !important; }

  .text-hide {
    ${new TextHide().include($)}
  }

  .text-decoration-none { text-decoration: none !important; }

  .text-break {
    word-break: break-word !important;
    word-wrap: break-word !important;
  }

  .text-reset { color: inherit !important; }
`;
